<template>
    <div class="home container-fluid">
        <div id="menu-mobile" v-bind:style="{top: window.height - 60 + 'px'}">
            <ul>
                <li><a href="#offerte"><b>OFFERTE</b></a></li>
                <li><a href="#partners"><b>PARTNERS</b></a></li>
                <li><a href="#certificazioni"><b>CERTIFICAZIONI</b></a></li>
                <li><a href="#contatti"><b>CONTATTI</b></a></li>
            </ul>
        </div>
        <div id="header" v-bind:style="{height: window.height + 'px'}">
            <div class="top col-12">
                <img class="logo" src="../assets/logo.svg">
                <div class="menu hidden-xs">
                    <img class="logo-sm" src="../assets/logo.svg">
                    <ul>
                        <li><a href="#offerte">OFFERTE</a></li>
                        <li><a href="#partners">PARTNERS</a></li>
                        <li><a href="#certificazioni">CERTIFICAZIONI</a></li>
                        <li><a href="#contatti">CONTATTI</a></li>
                    </ul>
                </div>
            </div>
            <div class="slogan row clearfix col-12">
                <p class="text-slogan col-12">Realizziamo impianti elettrici industriali e civili,<br>con impegno e
                    passione.</p>
                <p class="life col-12">LIGHT<br>YOUR<br>LIFE</p>
            </div>
        </div>
        <div id="offerte" class="col-12" name="offerte" v-bind:style="{height: window.height + 'px'}">
            <div class="title">OFFERTE</div>
            <div class="elenco-card">
                <carousel :navigationEnabled="true" :per-page="window.width < 600 ? 1 : 3" :scroll-per-page="false">
                    <slide v-for="(product, index) in products" :key="index">
                        <Card :product="product"></Card>
                    </slide>
                </carousel>
            </div>
        </div>
        <div id="partners" class="col-12" name="partners" v-bind:style="{height: window.height + 'px'}">
            <div class="title">PARTNERS</div>
            <div class="bg_partners"></div>
            <div class="loghi">
                <img src="../static/img/partners/ajax.png">
                <img src="../static/img/partners/bocchiotti.png">
                <img src="../static/img/partners/came.png">
                <img src="../static/img/partners/ditec.png">
                <img src="../static/img/partners/faac.png">
                <img src="../static/img/partners/inim.png">
                <img src="../static/img/partners/linergy.jpg">
                <img src="../static/img/partners/living_now.png">
                <img src="../static/img/partners/osram.jpg">
                <img src="../static/img/partners/vimar.png">
            </div>
        </div>
        <div id="certificazioni" class="col-12" name="certificazioni" v-bind:style="{height: window.height + 'px'}">
            <div class="title">CERTIFICAZIONI</div>
            <div class="elenco d-flex align-items-start flex-wrap">
                <div class="box d-flex flex-row col-12 col-md-6">
                    <img class="img_cert" src="../static/img/certificazioni/ajax.jpeg">
                </div>
                <div class="box d-flex flex-row col-12 col-md-6">
                    <img class="img_cert" src="../static/img/certificazioni/domotica.jpg">
                </div>
            </div>
        </div>
        <div id="contatti" class="col-12" name="contatti" v-bind:style="{height: window.height + 'px'}">
            <div class="title">CONTATTI</div>
            <div class="contatti">
                <div class="line">
                    <p class="label">Telefono: <a href="tel:+393497763793" class="detail">+393497763793</a></p>
                </div>
                <div class="line">
                    <p class="label">Indirizzo: <a class="detail">Via Giusti 27 21020 Casciago (VA) - Italy</a>
                    </p>
                </div>
                <div class="line">
                    <p class="label">E-mail: <a href="mailto:mail@samaimpianti.it" class="detail">mail@samaimpianti.it</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Card from "./Card";
    export default {
        name: 'HelloWorld',
        components: {Card},
        props: {
            msg: String
        },
        data() {
            return {
                window: {
                    height: 500,
                    width: 0
                },
              products: [
                {
                  img: require('../static/img/offerte/offerta_1_nera.jpg'),
                  description: ' <ul>\n' +
                    '                <li>Centrale ethernet/gsm Ajax Hub AJ-HUB-W</li>\n' +
                    '                <li>4x contatti porte/finestre  contatto magnetico AJ-DOORPROTECT-W</li>\n' +
                    '                <li>3x rilevatori di movimento wireless / PIR AJ-MOTIONPROTECT-W</li>\n' +
                    '                <li>2x telecomandi wireless AJ-SPACECONTROL-W</li>\n' +
                    '                <li>1x sirena da interno wireless AJ-HOMESIREN-W</li>\n' +
                    '                <li>1x sirena per esterni wireless AJ-STREETSIREN-W</li>\n' +
                    '                <li>1x tastiera indipendente a sfioramento AJ-KEYPAD-W</li>\n' +
                    '            </ul>',
                  price: '850,00',
                    title: 'Offerta Top Black/White'
                },
                  {
                      img: require('../static/img/offerte/offerta_2.jpg'),
                      description: ' <ul>\n' +
                          '                <li>Centrale ethernet/gsm Ajax Hub AJ-HUB-W</li>\n' +
                          '                <li>3x contatti porte/finestre  contatto magnetico AJ-DOORPROTECT-W</li>\n' +
                          '                <li>2x rilevatori di movimento wireless / PIR AJ-MOTIONPROTECT-W</li>\n' +
                          '                <li>2x telecomandi AJ-SPACECONTROL-W</li>\n' +
                          '                <li>1x sirena da interno wireless AJ-HOMESIREN-W</li>\n' +
                          '                <li>1x sirena per esterni wireless AJ-STREETSIREN-W</li>\n' +
                          '            </ul>',
                      price: '660,00',
                      title: 'Offerta Medium Black/White'
                  },
                  {
                      img: require('../static/img/offerte/kit_base.jpg'),
                      description: ' <ul>\n' +
                          '                <li>Centrale ethernet/gsm Ajax Hub AJ-HUB-W</li>\n' +
                          '                <li>1x contatti porte/finestre  contatto magnetico AJ-DOORPROTECT-W</li>\n' +
                          '                <li>1x rilevatori di movimento wireless / PIR AJ-MOTIONPROTECT-W</li>\n' +
                          '                <li>1x telecomandi wireless AJ-SPACECONTROL-W</li>\n' +
                          '            </ul>',
                      price: '310,00',
                      title: 'Kit Base'
                  },
              ]
            }
        },
        mounted: async function () {
            this.$nextTick(function () {
                const _this = this

                function setHeight() {
                    _this.window.height = window.innerHeight
                    _this.window.width = document.documentElement.clientWidth
                }

                setHeight()
                window.addEventListener('resize', () => {
                    setHeight()
                })
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
    @import "../assets/variabili.less";
    @import "../assets/font.less";

    .home {
        padding: 0 !important;

        .title {
            padding-top: 20px;
            .set-font(@family: 'druk-bold', @size: 3vw)
        }
        #menu-mobile{
            display: none;
        }
        #header {
            background: url("../assets/background.png") no-repeat center center;
            background-size: cover;

            .top {
                padding: 0;

                .logo {
                    width: 20%;
                    float: left;
                    z-index: 101;
                    position: relative;
                }

                .menu {
                    float: right;
                    height: 65px;
                    width: 100%;
                    position: fixed;
                    right: 0;
                    background-color: @bgMenu;
                    box-shadow: 0px 0px 10px @textColor;
                    z-index: 100;
                    .logo-sm{
                        height: 65px;
                        float: left;
                    }
                    ul {
                        width: 60%;
                        overflow: auto;
                        float: right;

                        li {
                            margin-top: 15px;
                            height: 35px;
                            line-height: 35px;
                            width: 25%;
                            float: left;
                            list-style: none;
                            border-right: 1px solid @firstColor;

                            a {
                                text-decoration: none;
                                .set-font(@family: "sama-medium", @color: @firstColor);
                            }

                            &:last-child {
                                border-right: 0px;
                            }
                        }
                    }
                }
            }

            .slogan {
                padding-top: 50px;
                padding-left: 10%;

                .text-slogan {
                    text-align: left;
                    .set-font(@size: 16px)
                }

                .life {
                    text-align: left;
                    .set-font(@family: "druk-super", @size: 5vw)
                }
            }
        }

        #offerte, #certificazioni {
            padding-top: 65px;
            .title {
                color: @firstColor;
            }

            .elenco-card{
                padding-left: 40px;
                padding-right: 40px;
                .VueCarousel-slide{
                    padding: 20px;
                    display: flex;
                    justify-content: center;
                }
            }
            .elenco {
                width: 80%;
                margin: auto;
                margin-top: 40px;
                height: 500px;

                .box {
                    img {
                        height: 40px;
                    }

                    .img_cert {
                        max-height: 350px;
                        height: auto;
                        margin: auto;
                    }

                    .title-offer {
                        margin: 0;
                        line-height: 40px;
                        padding-left: 15px;
                        .set-font(@family: 'sama-medium', @size: 25px, @color: @textColor)
                    }
                }
            }
        }

        #partners {
            padding-top: 65px;
            background-color: @black;

            .loghi {
                width: 75%;
                float: left;
                height: ~"calc(100% - 110px)";

                img {
                    margin: 25px 25px 0 0;
                    width: 150px;
                }
            }

            .bg_partners {
                width: 25%;
                float: left;
                background: url("../assets/partners.jpg") no-repeat top center;
                background-size: cover;
                height: ~"calc(100% - 110px)";
            }
        }

        #contatti {
            padding-top: 65px;
            background-color: @firstColor;

            .line {
                width: 100%;
                display: inline-block;
                margin-top: 50px;
                p {
                    margin: auto;
                    width: 420px;
                    text-align: left;
                    .set-font(@family: 'sama-medium', @color: @white,@size: 16px);
                    a{
                        .set-font(@color: @white ,@size: 16px);
                    }
                }
            }
        }
    }
    @media (max-width: 768px) {
        .home{
            #menu-mobile{
                display: block;
                position: fixed;
                width: 100%;
                height: 60px;
                z-index: 100;
                background-color: @white;
                box-shadow: 0 20px 15px 16px @black;
            ul {
                    width: 100%;
                    padding: 0;
                    overflow: auto;
                    li {
                        margin-top:15px;
                        height: 35px;
                        line-height: 35px;
                        width: 25%;
                        float: left;
                        list-style: none;
                        border-right: 1px solid @firstColor;
                        .set-font(@family: "sama-medium");
                        a {
                            text-decoration: none;
                            .set-font(@family: "sama-medium",@size: 10px, @color:@firstColor);
                        }

                        &:last-child {
                            border-right: 0px;
                        }
                    }
                }
            }
            #header{
                background-position: right center;
                .slogan{
                    .text-slogan{
                        text-align: right;
                    }
                    .life{
                        text-align: right;
                    }
                }
                .top{
                    .logo{
                        width: 50%;
                    }
                    .menu{
                        display: none;
                    }
                }
            }
            #offerte,#partners,#contatti,#certificazioni{
                padding-top: 0px;
            }
            #contatti {
                background-color: @firstColor;
                .line {
                    width: 100%;
                    margin-top: 50px;
                    p {
                        margin: auto;
                        width: auto;
                        text-align: left;
                        .set-font(@family: 'sama-medium', @color: @white,@size: 16px);
                        a{
                            .set-font(@color: @white ,@size: 16px);
                        }
                    }
                }
            }
            #partners{
                .bg_partners{
                    display: none;
                }
                .loghi{
                    width: 100%;
                    img{
                        float: left;
                        width: 25%;

                    }
                }
            }
        }
        .home {
            #offerte, #certificazioni{
                .elenco-card{
                    padding:0 10px;
                    .VueCarousel-slide{
                        padding:20px 0;
                    }
                }
                .elenco{
                    .box{
                        img{
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
</style>
